var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1_-_10",
    "data-name": "1 - 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00cf66;}.cls-2{fill:#00b157;}.cls-3{fill:#eaeff0;}.cls-4{fill:#d9e1e2;}.cls-5{fill:#009ae0;}.cls-6{fill:#0081bd;}.cls-7{fill:#fd3730;}.cls-8{fill:#d3241f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Library"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 6,
    width: 12,
    height: 36,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,6H5A3,3,0,0,0,2,9V39a3,3,0,0,0,3,3H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,14H5a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8,14V12H5a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,36H5a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8,36V34H5a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 15,
    y: 6,
    width: 12,
    height: 36,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21,6H18a3,3,0,0,0-3,3V39a3,3,0,0,0,3,3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,14H18a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21,14V12H18a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,36H18a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21,36V34H18a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.219,
    y: 5.735,
    width: 12,
    height: 36,
    rx: 3,
    transform: "translate(-4.875 10.442) rotate(-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.56,6.348l-2.9.777A3,3,0,0,0,27.541,10.8l7.765,28.978A3,3,0,0,0,38.98,41.9l2.9-.777Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.529,13.3l-5.8,1.553a1,1,0,0,1-.518-1.932l5.8-1.553a1,1,0,0,1,.518,1.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.631,14.076l-.518-1.932-2.9.776a1,1,0,0,0,.518,1.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.223,34.549l-5.8,1.553a1,1,0,1,1-.518-1.931l5.8-1.553a1,1,0,1,1,.518,1.931Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.325,35.326l-.518-1.932-2.9.777a1,1,0,1,0,.518,1.931Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ccd6b38f39028c43be466b112aa499da.svg";
export { ForwardRef as ReactComponent };